import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './Timer.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NoSleep from 'nosleep.js';

/**
 * Import components
 */
import Menu from 'components/UI/Menu/Menu';
import Popup from 'components/UI/Popup/Popup';
import TaskCardItem from 'components/UI/TaskCard/TaskCardItem/TaskCardItem';
import TimerBar from 'components/Homework/TimerBar/TimerBar';
import DefaultButton from 'components/UI/Button/Button';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

/**
 * Import Actions
 */

import updateTask from 'actions/task/update';

/**
 * Import Selectors
 */
import getTaskByDate from 'selectors/task/date';

const mapStateToProps = (state, props) => {

    let customProps = {
        ...props,
        date: new Date(props.match.params.date)
    };

    return {
        tasks: getTaskByDate(state, customProps),
        subjects: state.user_subject.entities,
        homework: state.homework.entities,
        colors: state.color.entities,
        user: state.authentication.user
    };
};

const mapDispatchToProps = {
    updateTask
};

let noSleep = new NoSleep();

class Timer extends Component {

    constructor() {
        super();

        this.videoRef = React.createRef();
        this.soundEffect = new Audio();

        this.state = {
            days: [ 'Zondag','Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag' ],
            months: [ 'januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december' ],
            ended: false,
            showMenu: false,
            timer: null,
            muted: false,
            timerCurrentTime: 0,
            timerTimeLeft: 0,
            timerImage: '/images/tracker/tracker1.png'
        };
        this.switchMuted             = this.switchMuted.bind(this);
        this.snoozeTimer             = this.snoozeTimer.bind(this);
        this.switchMenu              = this.switchMenu.bind(this);
        this.markTaskDone            = this.markTaskDone.bind(this);
        this.markTaskNotFinished     = this.markTaskNotFinished.bind(this);

        this.startTimer              = this.startTimer.bind(this);
        this.updateTimer             = this.updateTimer.bind(this);
        this.stopTimer               = this.stopTimer.bind(this);
        this.toggleTimer             = this.toggleTimer.bind(this);
        this.playFinishVideo         = this.playFinishVideo.bind(this);
    }

    switchMuted() {

        this.setState(prevState => {
            return {
                muted: !prevState.muted
            };
        });
    }

    startTimer() {
        this.soundEffect.pause();
        this.videoRef.current.play();
        let timer = setInterval(this.updateTimer, 1000);
        this.setState({ timer: timer });
        this.soundEffect.src = '';
        this.soundEffect.play();
    
        this.soundEffect.pause();
        this.videoRef.current.pause();
    }

    updateTimer() {

        if (this.state.timerTimeLeft <= 0) {
            this.myRef = React.createRef();
            this.stopTimer();
            this.soundEffect.src = '/audio/time_up.mp3';
            if (!this.state.muted) {
                this.soundEffect.play();
            }
            return;
        }

        let timerImage = '/images/tracker/tracker1.png';
        let percentage = Math.floor((this.state.timerTimeLeft / this.state.timerCurrentTime) * 100);

        if (percentage <= 75) {
            timerImage = '/images/tracker/tracker2.png';
        }
        if (percentage <= 50) {
            timerImage = '/images/tracker/tracker3.png';
        }
        if (percentage <= 25) {
            timerImage = '/images/tracker/tracker4.png';
        }

        this.setState({ timerTimeLeft: this.state.timerTimeLeft - 1, timerImage: timerImage });
    }

    stopTimer() {
        clearInterval(this.state.timer);
        this.setState({ timer: null, ended: true });
    }

    toggleTimer() {
        if (this.state.timer) {
            clearInterval(this.state.timer);
            this.setState({ timer: null });
            noSleep.disable();
        } else {
            let timer = setInterval(this.updateTimer, 1000);
            this.setState({ timer: timer });
            noSleep = new NoSleep();
            noSleep.enable();
        }
    }

    snoozeTimer() {
        this.setState({
            ended: false,
            timerCurrentTime: 300, //5 minutes
            timerTimeLeft: 300
        });

        this.startTimer();
    }

    switchMenu(e) {
        this.state.showMenu ? this.setState({ showMenu: false }) : this.setState({ showMenu: true });
    }

    onDragEnd(result) {
        const { destination, source, draggableId } = result;
        const task = this.props.task.byId[draggableId];

        if (!destination) {
            return;
        }

        if ( 
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        alert('No handeling of droppables in timer yet');
    }

    markTaskDone() {

        let currentTask = this.state.tasks[0];

        this.props.updateTask({ ...currentTask, status: 'finished' }).then((result) => {

            this.stopTimer();

            if (this.state.singleTask) {
                return this.props.history.push('/agenda');
            }
            
            let newTasks = this.state.tasks;
            newTasks.shift();

            if (newTasks.length > 0) {
                let time = (newTasks[0].time * 60);

                this.setState({
                    tasks: newTasks, 
                    ended: false,
                    timerCurrentTime: time,
                    timerTimeLeft: time
                });

                //this.startTimer();
            } else {

                this.setState({
                    tasks: newTasks, 
                });
                this.playFinishVideo();

            }           


        }).catch((error) => {console.error(error); alert('Er ging is mis het het opslaan van de taak');});

    }

    playFinishVideo() {
        this.videoRef.current.play();
        setTimeout(() => {
            this.props.history.push('/agenda');
        },5500);
       
    }

    markTaskNotFinished() {

        let currentTask = this.state.tasks[0];

        this.props.updateTask({ ...currentTask, status: 'not_finished' }).then((result) => {

            if (this.state.singleTask) {
                return this.props.history.push('/agenda');
            }
            
            let newTasks = this.state.tasks;
            newTasks.shift();

            let time = (newTasks[0].time * 60);

            this.setState({
                tasks: newTasks, 
                ended: false,
                timerCurrentTime: time,
                timerTimeLeft: time

            });

            this.startTimer();

        }).catch((error) => alert('Er ging is mis het het opslaan van de taak'));

    }

    componentDidMount() {
        window.scrollTo(0,0);

        let time = 0;
        let tasks;
        let ended = false;

        if (this.props.match.params.taskId) {
            this.setState({ singleTask: true });
            tasks = this.props.tasks.filter((task) => task.id == this.props.match.params.taskId);
            time = (tasks[0].time * 60);

        } else {

            tasks = this.props.tasks.sort((a,b) => a.order - b.order).filter((task) => task.status != 'finished');

            if (tasks.length > 0) {
                time = (tasks[0].time * 60);
            } else {
                ended = true;
                setTimeout(this.playFinishVideo, 1000);
            }
        }

        this.setState({
            date: new Date(this.props.match.params.date),
            tasks: tasks,
            timerCurrentTime: time,
            timerTimeLeft: time,
            ended: ended
        });

        //this.startTimer();
    }

    componentWillUnmount() {
        this.stopTimer();
    }

    render() {

        let date = this.state.date;
        if (!this.state.tasks) return null;

        let color = null;
        let homework;
        let subject;
        if (this.state.tasks.length > 0) {
            if (this.state.tasks[0].homework_id) {
                homework = this.props.homework.byId[this.state.tasks[0].homework_id];
                subject = this.props.subjects.byId[homework.user_subject_id];
                color = this.props.colors.byId[subject.color_id];
            } else {
                color = {
                    color: '#f8e764'
                };
            }         
        }

        return (
            <div styleName="timer-background">
                <div styleName='hamburger-icon' onClick={this.switchMenu}><FontAwesomeIcon styleName='icon' icon={[ 'far', 'bars' ]}/></div>
                <Popup handleClose={this.switchMenu} visible={this.state.showMenu} click={this.switchMenu}>
                    <Menu handleClose={this.switchMenu} open={this.state.showMenu} click={this.switchMenu}/>
                </Popup>
                <div styleName="title-bar">
                    <h1 styleName="title">Takenlijst</h1>
                    <div styleName='cross-icon' onClick={() => this.props.history.push('/agenda')}><FontAwesomeIcon styleName='icon' icon={[ 'far', 'times' ]}/></div>
                </div>
                <div styleName="content">
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <div styleName="timer-card">
                            <div styleName="top-bar">
                                <div styleName="date">
                                    <h1>{date && this.state.days[date.getDay()]}</h1>
                                    <p>{date && date.getDate()} {date && this.state.months[date.getMonth()]}</p>
                                </div>
                                <div styleName="icons">
                                    {
                                        this.props.user && this.props.user.use_timer ?
                                            <Fragment>
                                                <div styleName="icon" onClick={this.toggleTimer}>
                                                    <FontAwesomeIcon icon={[ 'fas',`${this.state.timer ? 'pause' : 'play'}` ]}/>
                                                </div>
                                                <div styleName="icon" onClick={this.switchMuted}>
                                                    <FontAwesomeIcon icon={this.state.muted ? [ 'fas','volume-slash' ] : [ 'fas','volume-up' ]}/>
                                                </div>
                                            </Fragment>
                                       
                                            : null
                                    }
                                    <div styleName="icon" onClick={this.markTaskDone}>
                                        <FontAwesomeIcon icon={[ 'fas','check' ]}/>
                                    </div>
                                </div>

                            </div>
                            <Droppable droppableId='timer-current'>
                                {(provided ) => (
                                    <div styleName="current-task" ref={provided.innerRef}
                                        {...provided.droppableProps} >

                                        {
                                            this.state.tasks.length > 0 && <TaskCardItem disableDrag extraStyleNames='timer-first-item' index={0} task={this.state.tasks[0]} dark timer order={1}></TaskCardItem>
                                        }
                                        {   (!this.state.ended &&
                                    <img src={this.state.timerImage}/>) ||
                                    <div styleName={`finish-buttons ${(this.state.tasks && this.state.tasks.length > 0) ? '' : 'hide'}`}>

                                        <p>Hey, de tijd voor deze taak zit erop. Je moet door met de volgende taak.</p>
                                        <DefaultButton timer icon={[ 'fas','step-forward' ]} small title='Nog niet klaar' handleClick={this.markTaskNotFinished}/>
                                        <DefaultButton timer bold icon={[ 'fas','check' ]} small title='Klaar!' handleClick={this.markTaskDone}/>
                                        <DefaultButton timer icon={[ 'fas','clock' ]} small title='Snooze (+5 min)' handleClick={this.snoozeTimer}/>
                                                

                                    </div>
                                        }
                                        <video styleName={`${(this.state.tasks && this.state.tasks.length > 0) ? 'hideVideo' : 'showVideo'}`} ref={this.videoRef} playsInline>
                                            <source src="/video/timer_finished.mp4" type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                        {
                                            provided.placeholder
                                        }
                                        {
                                            (this.state.tasks.length > 0 && this.props.user && this.props.user.use_timer) ? <TimerBar timeLeft={this.state.timerTimeLeft} totalTime={this.state.timerCurrentTime} color={color && color.color}/> : null
                                        }
                                    </div>
                                )}
                            </Droppable>
                            {
                                this.state.tasks.length > 1 &&
                                <Fragment>
                                    <h2 styleName='title'>Volgende</h2>
                            

                                    <Droppable droppableId='timer-up-next'>
                                        {(provided ) => (
                                            <div ref={provided.innerRef}
                                                {...provided.droppableProps} >
                                                <TaskCardItem disableDrag index={0} task={this.state.tasks[1]} dark timer order={1}>Dit is een test beschrijving</TaskCardItem>
                                                {
                                                    provided.placeholder
                                                }
                                            </div>
                                        )}
                                    </Droppable>
                                </Fragment>
                            }
                        </div>

                        {
                            this.state.tasks.length > 2 && //only show tasklist if we have enough tasks

                            <div styleName="task-card">
                                <h2 styleName="title">Takenlijst vandaag</h2>
                                <Droppable droppableId='timerlist'>
                                    {(provided ) => (
                                        <div styleName="cards" ref={provided.innerRef}
                                            {...provided.droppableProps} >
                                            {
                                                this.state.tasks.map((task, index) => {

                                                    if (index < 2) return;
                                                    return <TaskCardItem disableDrag index={index} task={task} dark timer order={1}></TaskCardItem>;
                                                })
                                            }
                                            {
                                                provided.placeholder
                                            }
                                        </div>
                                    )}
                                </Droppable>
                            </div>
                        }
                    </DragDropContext>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Timer);